import { getSearchMentionsV4 } from "@/api/endpoints/searches";
import { useFilterParamsV4 } from "@/hooks/useFilterParams";
import { useMarkSearchSeen } from "@/hooks/useMarkSearchSeen";
import { usePageParam } from "@/hooks/usePageParam";

import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import TopWidgets from "../partials/TopWidgetsNew";
import { Trans } from "@lingui/react/macro";
import SortButton from "../partials/SortButton";
import MentionCards from "@components/MentionCards";
import SmartRelevance from "./partials/SmartRelevance";

export default function MentionsListView() {
  // URL state
  const { orgUuid, uuid } = useParams<{
    uuid: string;
    orgUuid: string;
  }>();
  const [filters] = useFilterParamsV4();
  const [page, setPage] = usePageParam();

  // Server state
  const {
    data: mentionCardsData,
    isLoading: isMentionCardsLoading,
    error: mentionCardsError,
  } = useQuery({
    queryKey: [orgUuid, "searches", uuid, "mention-cards", filters, page],
    queryFn: () => {
      return getSearchMentionsV4(uuid, { ...filters, page });
    },
  });

  const llmIrrelevantMentionsCount = mentionCardsData?.ok
    ? mentionCardsData.data.llm_irrelevant_mentions_count
    : undefined;

  useMarkSearchSeen({
    orgUuid,
    searchUuid: uuid,
    enabled: !!mentionCardsData?.ok && mentionCardsData.data.results.length > 0,
  });

  return (
    <div className="flex flex-col gap-8">
      <TopWidgets searchUuid={uuid} orgUuid={orgUuid} filters={filters} />

      {llmIrrelevantMentionsCount ? (
        <SmartRelevance
          llmIrrelevantMentionsCount={llmIrrelevantMentionsCount}
          searchUuid={uuid}
          orgUuid={orgUuid}
        />
      ) : null}

      <div className="flex flex-col gap-5">
        <div className="flex items-end justify-between flex-wrap gap-4">
          <div className="flex flex-col gap-1">
            <h2 className="text-xl font-semibold">
              <Trans>Träffar</Trans>
            </h2>

            <p className="text-sm text-muted-foreground text-balance">
              <Trans>
                De senaste träffarna från dina källor, sortera efter datum eller
                relevans.
              </Trans>
            </p>
          </div>

          <SortButton orgUuid={orgUuid} searchUuid={uuid} />
        </div>

        <MentionCards
          isMentionCardsLoading={isMentionCardsLoading}
          mentionCardsError={mentionCardsError}
          mentionCardsData={mentionCardsData}
          onChangePage={setPage}
          orgUuid={orgUuid}
          page={page}
        />
      </div>
    </div>
  );
}
